<template lang="html">
  <div class="skitter skitter-large position-relative">
    <ul>
      <li class="">
        <a href="#swapBarsBack">
          <img src="/images/slider/slide_2.jpg" class="swapBarsBack" />
        </a>
        <div class="label_text position-absolute">
          <h3 class="h1 text-light slide-label">HEALTH CARE</h3>
          <!-- <a href="" class="btn btn-light shop-now-btn">Shop Now</a> -->
          <router-link to="/products" class="main-btn">
            <span class="text">Shop Now</span>
            <span class="semicircle"></span>
          </router-link>
        </div>
      </li>
      <li>
        <a href="#swapBarsBack">
          <img src="/images/slider/slide_1.jpg" class="swapBarsBack" />
        </a>
        <div class="label_text position-absolute">
          <h3 class="h1 text-light slide-label">HEALTH CARE</h3>
          <!-- <a href="" class="btn btn-light shop-now-btn">Shop Now</a> -->
          <router-link to="/products" class="main-btn">
            <span class="text">Shop Now</span>
            <span class="semicircle"></span>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted(){
    $(function() {
      $('.skitter-large').skitter({
        navigation: true,
        fullscreen: true,
        // focus: true,
        progressbar: true,
        dots: false,
        theme: 'clean'
      });
    });
  }
}
</script>

<style lang="css">
.skitter{
  max-width: 100%;
}
.skitter-clean .prev_button{
  left: 5px;
}
.skitter-clean .next_button{
  right: 5px;
}
.skitter-clean .prev_button:after, .skitter-clean .next_button:after{
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 6px 50% 50% 6px;
  background-color: #fff;
  color: #fff;
  background-image: url('/images/arrows/right-a.png');
  background-repeat: no-repeat;
  background-size: 40% 80%;
  background-position: center center;
}

.skitter-clean .prev_button:after{
  background-image: url('/images/arrows/left-a.png');
  border-radius: 50% 6px 6px 50% ;
}
.label_skitter{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent
}

.skitter .main-btn {
  padding: 14px 30px;
  border-radius: 40px;
  position: relative;
  text-transform: uppercase;
  background-color: var(--main-color);
  border: 2px solid transparent;
  color: #fff;
  transition: 0.3s;
}

.skitter .main-btn:hover,
.skitter .main-btn:hover .semicircle:after {
  color: var(--main-color);
  box-shadow: 9px 9px 9px 0 rgba(47, 44, 44, 0.2);
  background-color: transparent;
  border: 2px solid var(--main-color);
}

.skitter .main-btn:hover .semicircle:after {
  border: 2px solid var(--main-color);
}

.skitter .main-btn .semicircle {
  position: absolute;
  top: 7px;
  left: 12px;
  width: 18px;
  height: 18px;
  overflow: hidden;
}

.skitter .main-btn .semicircle:after {
  content: "";
  display: block;
  position: absolute;
  width: 35px;
  height: 35px;
  border: 2px solid #fff;
  border-radius: 100%;
}

</style>
